// extracted by mini-css-extract-plugin
module.exports = {"optionStyle":"zCD1VJchfFRfGBAZD4sls","healthStyle":"ROEVP10bUCxKjsm2oT9sJ"};